export const css = {
	oneaction: '_1EYxaT-n',
	' _key': 'certwise-theme/certwise/quiz-widgets/questionfeedback'
};

export default css;
